<div class="flex flex-col">
    <!-- Header -->
    <div
        class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">
            <b>{{ 'workerHourBag.title' | transloco: { worker: data.row.displayName} }}</b>
        </div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-col items-center justify-center py-8">
    @if (!isHourBagActive()) {
        <span class="text-lg font-medium text-primary">
            {{ 'workerHourBag.askActivate' | transloco }}
        </span>
    } @else {
        <span class="text-lg font-medium text-green-600">
            {{ 'workerHourBag.askDeactivate' | transloco }}
        </span>
    }
</div>

<div class="flex flex-0 flex-row justify-end gap-2 px-6 py-4 bg-gray-50 dark:bg-black dark:bg-opacity-10">
    <button (click)="closeDialog()" mat-stroked-button>
        {{ 'cancel' | transloco }}
    </button>
    <button (click)="approve()" mat-flat-button color="primary">
        {{ 'accept' | transloco }}
    </button>
</div>
